export default "__VITE_ASSET__D1$yJoO2__"